const locations = {
  toast: {
    error: {
      badResponse: '[מיקומים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[מיקומים] נוצר בהצלחה',
      },
      edit: {},
      delete: {
        default: '[מיקומים] נמחק בהצלחה',
      },
    },
  },
  headerButtons: {
    create: {
      createBtn: 'הוסף',
    },

    import: 'ייבא',
  },

  deleteModal: {
    header: 'מחק מיקומים',
    body: 'אתה עומד למחוק {{num}} מיקומים.',
  },

  printoutsModal: {
    title: 'ייצוא PDF של תדפיסים',
    description: 'נא לבחור טווח תאריכים (מקסימום 31 ימים)',
    maxRangeError: 'נא לבחור טווח של 31 ימים או פחות',
    export: 'ייצוא',
  },

  table: {
    filters: {
      type: 'סוג',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
      printouts: 'תדפיסים',
    },
    moreActions: {
      showOnMap: 'הצג על המפה',
    },
    headers: {
      name: 'שם',
      type: 'סוג',
      address: 'כתובת',
      lat: 'קו רוחב',
      lon: 'קו אורך',
      locationTypes: {
        location: 'מיקום',
        inAndOut: 'כניסה ויציאה',
        airport: 'נמל תעופה',
        facility: 'מתקן',
      },
      wait: 'המתן',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  form: {
    header: {
      createLocation: {
        title: 'הוסף',
      },

      updateLocation: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    addressInformation: {
      title: 'מידע על כתובת',
      name: 'שם',
      type: 'סוג',
      wait: 'המתן',
      address: 'כתובת',
      locationTypes: {
        location: 'מיקום',
        inAndOut: 'כניסה ויציאה',
        airport: 'נמל תעופה',
        facility: 'מתקן',
      },
      radius: 'רדיוס התאמת כתובת',
    },
    radius: {
      title: 'רדיוס התאמת כתובת',
      toolTipInformation: "הרדיוס במטרים או רגליים (מ'/ר' עבור מטרי/אימפריאלי) שבו הזמנות מזוהות כמיקום ו/או כהמתנה וחזרה",
    },
    waitAndReturn: {
      title: 'המתן וחזור',
      time: 'זמן המתנה',
      timeDescription: 'משך הזמן בדקות שבו נהג ימתין בין הנסיעה הלוך לחזור בנסיעת המתן וחזור.',
    },
    advancedSettings: {
      consistentPassengerRouting: {
        title: 'ניתוב עקבי לנוסעים',
        toolTipInformation:
          'מבטיח שהקבוצה הקבועה של הנוסעים תמיד תעקוב אחר אותו המסלול אל ומהמתקן, תוך אופטימיזציה של יעילות הנסיעה ומינימום בלבול.',
      },
      snapAddressWithinRadius: {
        title: 'הצמד כתובת בתוך רדיוס',
        toolTipInformation: 'כאשר נקודת איסוף/הורדה נמצאת בתוך רדיוס המיקום, מתבצעת הצמדה לשם ולקואורדינטות של המיקום',
      },
      sameDriverForGroup: {
        toolTipInformation: 'מקצה את אותו נהג להסעת קבוצת הנוסעים גם לאיסוף וגם להורדה, לצורך היכרות ועקביות',
        title: 'אותו נהג לקבוצה',
      },
      overrideOptions: {
        bySystemSettings: 'לפי הגדרות המערכת',
        enabled: 'מופעל',
        disabled: 'מושבת',
      },
      allowSharedRide: {
        title: 'אפשר נסיעה משותפת עם כתובות אחרות',
        toolTipInformation:
          'כאשר אפשרות זו מופעלת, ניתן לשלב נסיעות משותפות עם הזמנות מאזורים אחרים עם מסלולים עקביים. אם האפשרות מושבתת, רק נסיעות מאותו מיקום יישקלו לשילוב.',
      },
      tripBoardingTime: {
        title: 'זמן עלייה',
        toolTipInformation: 'משך הזמן הדרוש לאיסוף נוסע בנקודת העצירה שלו (פרמטר זה ישפיע על זמן הנסיעה הכולל)',
      },
      waitForBoardingTime: {
        title: 'המתנה לזמן העלייה',
        toolTipInformation: 'כאשר מגיעים לעצירה, הנהג ימתין עד לזמן האיסוף המדויק, אם נדרש.',
      },
      tripDropOffTime: {
        title: 'זמן הורדה',
        toolTipInformation: 'משך הזמן הדרוש להורדת נוסע בנקודת העצירה שלו (פרמטר זה ישפיע על זמן הנסיעה הכולל).',
      },

      maxDropOffEarly: {
        title: 'מקסימום הגעה מוקדמת ליעד',
        toolTipInformation: 'מספר הדקות המרבי שנהג יכול להקדים ביחס לשעת הירידה שנקבעה בהזמנה',
      },
      maxDropOffDelay: {
        title: 'מקסימום איחור בהגעה ליעד',
        toolTipInformation: 'מספר הדקות המרבי שנהג יכול לאחר ביחס לשעת הירידה שנקבעה בהזמנה',
      },
      maxBoardingDelay: {
        title: 'מקסימום איחור באיסוף',
        toolTipInformation: 'מספר הדקות המרבי שנהג יכול לאחר ביחס לשעת האיסוף שנקבעה בהזמנה',
      },
      maxBoardingEarly: {
        title: 'מקסימום הגעה מוקדמת לאיסוף',
        toolTipInformation: 'מספר הדקות המרבי שנהג יכול להקדים ביחס לשעת האיסוף שנקבעה בהזמנה',
      },
      maxTripDuration: {
        title: 'משך נסיעה מרבי',
        toolTipInformation: 'משך הזמן המרבי של נסיעה בדקות',
      },
      maxSinglePassengerTime: {
        title: 'משך נסיעה מרבי לנוסע יחיד',
        toolTipInformation: 'משך הזמן המרבי של נסיעה בדקות לנוסע יחיד',
      },
    },
    advanced: {
      title: 'מתקדם',
      addTime: {
        addTimeBtn: 'הוסף זמן',
        name: 'שם',
        minutes: 'דקות',
        enterMinutes: 'הזן דקות',
        enterName: 'הזן שם',
      },
    },
    map: {
      title: 'מפה',
    },
    site: {
      title: 'אתר',
    },

    info: {
      subLocations: {
        addSubLocationBtn: 'הוסף טרמינל',
        header: 'טרמינל',
        fields: {
          subLocation: 'כתובת',
          name: {
            label: 'שם כתובת',
            placeholder: 'שם',
          },
        },
      },
    },
  },

  update: {
    confirmButtonText: 'עדכן',
    formTabs: {
      info: 'מידע',
      advancedSettings: 'הגדרות מתקדמות',
      history: 'היסטוריה',
    },
    successToast: {
      message: 'נוצר! המיקום עודכן בהצלחה.',
    },

    errorToast: {
      message: 'שגיאה. לא ניתן לעדכן מיקום.',
    },
  },
  create: {
    formTabs: {
      info: 'מידע',
      advancedSettings: 'הגדרות מתקדמות',
    },
    successToast: {
      message: 'נוצר! המיקום נוצר בהצלחה.',
    },

    errorToast: {
      message: 'שגיאה. לא ניתן ליצור מיקום.',
    },
  },

  delete: {
    successToast: {
      message: 'נמחק! המיקום נמחק בהצלחה.',
    },

    errorToast: {
      message: 'שגיאה. לא ניתן למחוק מיקום.',
    },
  },

  createModal: {
    title: 'המתן וחזור',
    body: "אתה עומד להגדיר מיקום זה כמיקום 'המתן וחזור'. פעולה זו תחיל באופן אוטומטי את הגדרת 'המתן וחזור' על כל ההזמנות העתידיות במיקום זה. האם אתה בטוח שברצונך להמשיך?",
  },
  enableLocationTypeModal: {
    title: 'המתן וחזור',
    body: "אתה עומד להפעיל את הגדרת 'המתן וחזור'. הגדרה זו תחול על כל ההזמנות הנוכחיות והעתידיות אשר עומדות בקריטריונים של 'המתן וחזור'. האם אתה בטוח שברצונך להמשיך?",
  },
  disableLocationTypeModal: {
    title: 'המתן וחזור',
    body: "אתה עומד לבטל את הגדרת 'המתן וחזור'. פעולה זו תסיר את ההגדרה מכל ההזמנות הנוכחיות והעתידיות המזוהות כהמתן וחזור. האם אתה בטוח שברצונך להמשיך?",
  },
  deleteLocationTypeModal: {
    title: 'אתה עומד למחוק {{count}} מיקומים.',
    titleAll: 'אתה עומד למחוק את כל המיקומים.',
    body: "אתה עומד למחוק מיקום זה כמיקום 'המתן וחזור'. פעולה זו תבטל את הגדרת 'המתן וחזור' על כל ההזמנות העתידיות במיקום זה. האם אתה בטוח שברצונך להמשיך?",
  },
  updateLocationOfTypeLocationModal: {
    title: 'המתן וחזור',
    body: "אתה עומד לשנות מיקום זה למיקום 'המתן וחזור'. פעולה זו תחיל באופן אוטומטי את הגדרת 'המתן וחזור' על כל ההזמנות העתידיות במיקום זה. האם אתה בטוח שברצונך להמשיך?",
  },
};

export default locations;
